import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const CustomerFilterServiceConfig = {
  name: "CustomerFilter",
  annotations: []
} as ServiceConfig;